export default "__VITE_ASSET__BwmEmyWA__"